import {useLocation} from "@gatsbyjs/reach-router";

export const useQuery = queryParam => {
  const search = new URLSearchParams(useLocation().search);
  return search.get(queryParam);
};
